import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Link from 'valuelink';
import { Input } from 'valuelink/lib/tags';

import { loginUser, googleLoginUser } from '../../actions/index';
import { SemiboldText } from '../../components/common/Text';
import box_pattern from '../../images/onboarding/box_pattern.png';
import { PrimaryButton } from '../../components/common/Buttons';
import { GoogleLogin } from '@react-oauth/google';
import config from '../../../config';
import { sendGoogleLogin } from '../../services/auth';
import ProxyGoogleLoginButton from '../../components/ProxyGoogleLoginButton';

const OuterContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  justify-content: center;
`;

const TitleContainer = styled.div`
  position: relative;
  overflow: visible;
  z-index: 1;
  margin-left: 0.625rem;
  margin-right: 0.625rem;
`;

const TitleText = styled(SemiboldText)`
  font-size: 1.5rem;
  text-align: center;
  color: #47464a;
  margin-left: 0.625rem;
  margin-bottom: 1.625rem;
  margin-right: 0.625rem;
`;

const GridIcon = styled.img`
  position: absolute;
  right: 0;
  top: -25px;
  width: 50px;
  height: 50px;
`;

const InputContainer = styled.div`
  background-color: #f8f8f8;
  padding: 0.68rem 0;
  width: 254px;
  border-radius: 6px;
  display: flex;
  /* align-self: stretch; */
  align-self: center;
  align-items: center;
  margin-bottom: 0.625rem;
  /* margin-left: 1.625rem;
  margin-right: 1.625rem; */
`;

const StyledButtonText = styled(SemiboldText)`
  color: white;
  flex: 0;
  /* text-transform: uppercase; */
  /* text-align: center; */
`;

const StyledInputBox = styled(Input)`
  background-color: #f8f8f8;
  text-align: center;
  /* margin-right: 1.875rem; */
  flex: 1;
  width: 205px;
`;

const SubmitButton = styled(PrimaryButton)`
  align-self: center;
  justify-content: center;
  align-items: center;
  margin-top: 1.25rem;
  width: 300px;
`;

class LoginScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      password: '',
      loading: false,
    };
  }

  overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '10vh',
    backgroundColor: 'rgb(0, 183, 183)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '2rem',
  };

  overlayTextStyle = {
    color: 'white',
    fontSize: '2rem',
    textAlign: 'center',
  };

  handleKeyPress = (event) => {
    // console.log({ event, focus: document.activeElement.id });
    if (event.code === 'Enter') {
      this.login();
    }
  };
  responseMessage = (response) => { };
  errorMessage = (error) => {
    console.log(error);
  };

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyPress, false);

    if (this.props.authToken) {
      this.props.history.push('/home');
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyPress, false);
  }

  componentWillUpdate = () => {
    // otp error then change loading back to false
    if (this.state.loading && this.props.appError.hasError) {
      this.setState({
        loading: false,
      });
    }
  };

  // googleAuthLogin = async (loginResponse) => {
  //   const dispatch = this.props.dispatch;
  //   return sendGoogleLogin(loginResponse.credential).then((response) => {
  //     if (response && response.body.message === 'success') {
  //       dispatch(setUserInfo(response.body.result));
  //       dispatch(setAuthToken(response.headers.authorization));
  //       // return response.operatorDetails;
  //       console.log('Naruto' + response);
  //       return response;
  //     }
  //     throw new Error('Logged message not correct');
  //   });
  // };

  login = () => {
    this.setState({
      loading: true,
    });

    // login
    const { dispatch, history } = this.props;
    const { userName, password } = this.state;
    dispatch(loginUser(userName, password, history));
  };

  googleAuthLogin = async (loginResponse) => {
    // this.setState({
    //   loading: true,
    // });
    //console.log('Phone number submitted', loginResponse);
    const token = loginResponse.credential;
    // login
    const { dispatch, history } = this.props;
    //const { token } = this.state;
    dispatch(googleLoginUser(token, history));
  };

  render() {
    const userNameLink = Link.state(this, 'userName');
    const passwordLink = Link.state(this, 'password');
    return (
      <OuterContainer>
        {/* <TitleContainer>
          <GridIcon src={box_pattern} />
          <TitleText>Kindly login to your account</TitleText>
        </TitleContainer>
        <InputContainer>
          <StyledInputBox
            className="visit-input"
            valueLink={userNameLink}
            placeholder="User Name"
          />
        </InputContainer>
        <InputContainer>
          <StyledInputBox
            className="visit-input"
            valueLink={passwordLink}
            placeholder="Password"
            type="password"
          />
        </InputContainer>
        <SubmitButton onTap={this.login} loading={this.state.loading}>
          <StyledButtonText>Continue</StyledButtonText>
        </SubmitButton> */}

        <div style={this.overlayStyle}>
          <p style={this.overlayTextStyle}>Visit Network Dashboard</p>
        </div>
        <div
          style={{
            padding: '5rem',
            marginTop: '10rem',
            display: 'flex',
            width: 'auto',
            justifyContent: 'space-around',
          }}
        >
          {config.useNativeGoogleAuth ? (
            <GoogleLogin
              clientId={config.googleAuthConfig.clientId}
              onSuccess={this.googleAuthLogin}
              onError={this.errorMessage}
              scope={config.googleAuthConfig.scopes}
              prompt="consent"
              layout="horizontal"
              theme="filled_blue"
              shape="pill"
            />
          ) : (
            <ProxyGoogleLoginButton loading={this.state.loading} />
          )}
        </div>
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  appError: state.app.appError,
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(LoginScreen);
